import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import router from "./navigation/Router";
import ErrorService from "./services/ErrorService";
import LanguageService from "./services/LanguageService";
import ChakraProvider from "./context/theme/ChakraProvider";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      gcTime: 0,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ChakraProvider>
        <RouterProvider router={router} />
      </ChakraProvider>
      <ErrorService />
      <LanguageService />
    </QueryClientProvider>
  );
}

export default App;
